import { ProductGtmEvents } from '@/gtm/product/product-gtm-events';

export class ProductAvailabilityGtmEvents extends ProductGtmEvents {
  clickListView({ cityName }) {
    return this.gtmEvent({
      eventAction: 'Карточка_НаличиеВМагазинах_Список_Клик',
      eventLabel: cityName,
    });
  }

  clickMapView({ cityName }) {
    return this.gtmEvent({
      eventAction: 'Карточка_НаличиеВМагазинах_Карта_Клик',
      eventLabel: cityName,
    });
  }

  changeMap({ productCode, cityName }) {
    return this.gtmEvent({
      eventAction: 'Карточка_НаличиеВМагазинах_Карта_Взаимодействие',
      eventLabel: `${productCode}|${cityName}`,
    });
  }

  chooseStoreOnMap({ productCode, cityName, storeId }) {
    return this.gtmEvent({
      eventAction: 'Карточка_НаличиеВМагазинах_Карта_ВыбратьМагазин',
      eventLabel: `${productCode}|${cityName}|${storeId}`,
    });
  }

  addToCartOnMap({ productCode, cityName, storeId }) {
    return this.gtmEvent({
      eventAction: 'Карточка_НаличиеВМагазинах_Карта_ЗабратьИзМагазина',
      eventLabel: `${productCode}|${cityName}|${storeId}`,
    });
  }

  addToCartInList({ productCode, cityName, storeId }) {
    return this.gtmEvent({
      eventAction: 'Карточка_НаличиеВМагазинах_Список_ЗабратьИзМагазина',
      eventLabel: `${productCode}|${cityName}|${storeId}`,
    });
  }

  clickColorFilter({ productCode }) {
    return this.gtmEvent({
      eventAction: 'Карточка_НаличиеВМагазинах_ВыборЦвета',
      eventLabel: productCode,
    });
  }

  chooseColor({ productCode, colorName }) {
    return this.gtmEvent({
      eventAction: 'Карточка_НаличиеВМагазинах_УспешныйВыборЦвета',
      eventLabel: `${productCode}|${colorName}`,
    });
  }

  clickSizeFilter({ productCode }) {
    return this.gtmEvent({
      eventAction: 'Карточка_НаличиеВМагазинах_ВыборРазмера',
      eventLabel: productCode,
    });
  }

  chooseSize({ productCode, size }) {
    return this.gtmEvent({
      eventAction: 'Карточка_НаличиеВМагазинах_УспешныйВыборРазмера',
      eventLabel: `${productCode}|${size}`,
    });
  }

  toggleInStore({ productCode, cityName, value }) {
    return this.gtmEvent({
      eventAction: value
        ? 'Карточка_НаличиеВМагазинах_НаличиеСейчасВкл'
        : 'Карточка_НаличиеВМагазинах_НаличиеСейчасВыкл',
      eventLabel: `${productCode}|${cityName}`,
    });
  }
}
